import { ChargeConstant } from "presentation/constant/ChargeHeader/ChargeConstant";
import { ReqModeDroOpts } from "presentation/constant/DropDownOptions/Document/ReqModeDroOpts";
import { RequisitionFormConstant } from "presentation/constant/RequisitionForm/RequisitionFormConstant";
import { useRequisitionFormVM } from "presentation/hook/RequisitionForm/useRequisitionFormVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useRequisitionFormMaintenanceTracked } from "presentation/store/RequisitionForm/RequisitionFormMaintenanceProvider";
import { memo, useCallback, useState } from "react";
import { HPHBreadcrumb, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const RequisitionFormEditPanelTitleBar: React.FC = () => {
    const [requisitionFormState] = useRequisitionFormMaintenanceTracked();
    const requisitionFormVM = useRequisitionFormVM();
    const messageBarVM = useMessageBarVM();
    const { currentRequisitionForm, masterState, isIC, isAC, isFIN, isCOM, isMD, isGMD, reqNatureKeyMap } = requisitionFormState;
    const { editingEntity, isAdd, isEditable, isRead } = masterState;

    const [anainfoState] = useANAInfoTracked();
    const { allowCreate, allowUpdate } = anainfoState;
    const [isLoading, setIsLoading] = useState(false);
    const currentEntity = isRead ? currentRequisitionForm : editingEntity;

    const handleReset = useCallback(async () => {
        requisitionFormVM.onResetClick();
    }, [requisitionFormVM]);

    const handleEdit = useCallback(() => {
        requisitionFormVM.onEdit(currentEntity);
    }, [currentEntity, requisitionFormVM])

    const handleSave = useCallback(async () => {
        let errorMsg = null;
        if (currentEntity && currentEntity.reqMode && ReqModeDroOpts().getKeyByValue(currentEntity.reqMode) !== "AN"
            && !(currentEntity.customers && currentEntity.customers.length > 0)) {
            messageBarVM.showError("Please add a customer at least.");
            return;
        }
        currentEntity.mgrs?.forEach(mgr => {
            if (mgr.confirmDatetime && !mgr.mgrName) {
                errorMsg = "Please input manager Name, if you enter confirmed date time.";
                return;
            }
        });
        let verifyRequiredFields: { [x: string]: string } = {}
        const mgrIC = currentEntity.mgrs?.find(mgr => mgr.mgrPosition === "MGR_IC");
        if (isIC) {
            if (!mgrIC?.mgrName) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    mgrIcName: 'Missing.'
                }
            }
            if (!mgrIC?.confirmDatetime) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    mgrIcConfirmDatetime: 'Missing.'
                }
            }
        } else {
            if (mgrIC?.confirmDatetime && !mgrIC?.mgrName) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    mgrIcName: 'Missing.'
                }
            }
        }
        if (mgrIC?.confirmDatetime && new Date(mgrIC.confirmDatetime).getTime() > new Date().getTime()) {
            verifyRequiredFields = {
                ...verifyRequiredFields,
                mgrIcConfirmDatetime: 'should be smaller than current Date.'
            }
        }
        const mgrAC = currentEntity.mgrs?.find(mgr => mgr.mgrPosition === "MGR_AC");
        if (isAC) {
            if (!mgrAC?.mgrName) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    mgrAcName: 'Missing.'
                }
            }
            if (!mgrAC?.confirmDatetime) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    mgrAcConfirmDatetime: 'Missing.'
                }
            }
        } else {
            if (mgrAC?.confirmDatetime && !mgrAC?.mgrName) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    mgrAcName: 'Missing.'
                }
            }
        }

        if (mgrAC?.confirmDatetime && new Date(mgrAC.confirmDatetime).getTime() > new Date().getTime()) {
            verifyRequiredFields = {
                ...verifyRequiredFields,
                mgrAcConfirmDatetime: 'should be smaller than current Date.'
            }
        }

        const mgrFIN = currentEntity.mgrs?.find(mgr => mgr.mgrPosition === "FIN");
        if (isFIN) {
            if (!mgrFIN?.mgrName) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    finName: 'Missing.'
                }
            }
            if (!mgrFIN?.confirmDatetime) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    finConfirmDatetime: 'Missing.'
                }
            }
        } else {
            if (mgrFIN?.confirmDatetime && !mgrFIN?.mgrName) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    finName: 'Missing.'
                }
            }
            // verifyRequiredFields = {
            //     ...verifyRequiredFields,
            //     finName: 'Missing.'
            // }
        }

        if (mgrFIN?.confirmDatetime && new Date(mgrFIN.confirmDatetime).getTime() > new Date().getTime()) {
            verifyRequiredFields = {
                ...verifyRequiredFields,
                finConfirmDatetime: 'should be smaller than current Date.'
            }
        }


        const mgrCOM = currentEntity.mgrs?.find(mgr => mgr.mgrPosition === "COM");
        if (isCOM) {
            if (!mgrCOM?.mgrName) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    comName: 'Missing.'
                }
            }
            if (!mgrCOM?.confirmDatetime) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    comConfirmDatetime: 'Missing.'
                }
            }

        } else {
            if (mgrCOM?.confirmDatetime && !mgrCOM.mgrName) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    comName: 'Missing.'
                }
            }
        }
        if (mgrCOM) {
            if (mgrCOM.confirmDatetime && new Date(mgrCOM.confirmDatetime).getTime() > new Date().getTime()) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    comConfirmDatetime: 'should be smaller than current Date.'
                }
            }
        }

        const mgrMD = currentEntity.mgrs?.find(mgr => mgr.mgrPosition === "MD");
        if (isMD) {

            if (!mgrMD?.mgrName) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    mdName: 'Missing.'
                }
            }
            if (!mgrMD?.confirmDatetime) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    mdConfirmDatetime: 'Missing.'
                }
            }

        } else {
            if (mgrMD?.confirmDatetime && !mgrMD.mgrName) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    mdName: 'Missing.'
                }
            }
        }
        if (mgrMD) {
            if (mgrMD.confirmDatetime && new Date(mgrMD.confirmDatetime).getTime() > new Date().getTime()) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    mdConfirmDatetime: 'should be smaller than current Date.'
                }
            }
        }

        const mgrGMD = currentEntity.mgrs?.find(mgr => mgr.mgrPosition === "GMD");
        if (isGMD) {
            if (!mgrGMD?.mgrName) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    gmdName: 'Missing.'
                }
            }
            if (!mgrGMD?.confirmDatetime) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    gmdConfirmDatetime: 'Missing.'
                }
            }

        } else {
            if (mgrGMD?.confirmDatetime && !mgrGMD.mgrName) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    gmdName: 'Missing.'
                }
            }
        }
        if (mgrGMD) {
            if (mgrGMD.confirmDatetime && new Date(mgrGMD.confirmDatetime).getTime() > new Date().getTime()) {
                verifyRequiredFields = {
                    ...verifyRequiredFields,
                    gmdConfirmDatetime: 'should be smaller than current Date.'
                }
            }
        }
        if (errorMsg) {
            messageBarVM.showError(errorMsg);
            return;
        }
        setIsLoading(true);
        try {
            requisitionFormVM.onSaveClicked();
            const res = await requisitionFormVM.onSave(reqNatureKeyMap, currentEntity, isAdd, verifyRequiredFields);
            if (res && res["mandatoryCheckFail"]) {
                // messageBarVM.showError(res["mandatoryCheckFail"]?.toString());
                setIsLoading(false)
                return;
            } else if (res) {
                setIsLoading(false)
                messageBarVM.showError(res.data);
                return;
            } else {
                setIsLoading(false)
                messageBarVM.showSuccess("Save Successfully.");
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }

    }, [currentEntity, isIC, isAC, isFIN, isCOM, isMD, isGMD, messageBarVM, requisitionFormVM, reqNatureKeyMap, isAdd]);

    const isShowEdit = useCallback(() => {
        if (currentEntity && currentEntity.state === 'INV') return false;
        return true;
    }, [currentEntity])

    return <Sidebarheader style={{ width: '100%' }}>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
        <Breadcrumb>
            <HPHBreadcrumb breadcrumbData={[{ title: ChargeConstant.Charge.CHARGE },
            { title: RequisitionFormConstant.TITLE }]} onCurrentClick={() => { }}></HPHBreadcrumb>
        </Breadcrumb>
        <StyledAction>
            {(!isAdd && (isEditable && isRead)) &&
                <>
                    {/* Edit Button */}
                    {
                        (
                            (isEditable && allowUpdate && isShowEdit())
                        )
                        && <IconButton fileName='Icon-pen' size='medium' toolTipText={'Edit'} toolTipArrow={false} onClick={handleEdit} />
                    }
                    {/* Close Button */}
                    <IconButton fileName='Icon-cross' size='medium' toolTipText={'Close'} toolTipArrow={false} onClick={requisitionFormVM.onCloseClick} />
                </>}
            {(isAdd || (isEditable && !isRead)) &&
                <>
                    {/* Reset Form Button */}
                    <IconButton fileName="Icon-reset" size="medium" toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={handleReset} />
                    {/* Close Button */}
                    <IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="left" toolTipText={'Close'} onClick={requisitionFormVM.onCloseClick} />
                    {/* Save Button */}
                    {
                        (
                            (isAdd && allowCreate) ||
                            (isEditable && allowUpdate)
                        )
                        && <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />
                    }
                </>}
        </StyledAction>
    </Sidebarheader>
}

export default memo(RequisitionFormEditPanelTitleBar);